import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NuevaCotizacion from './pages/NuevaCotizacion';
import VerCotizacion from './pages/VerCotizacion';
import EditarCotizacion from './pages/EditarCotizacion';
import Clientes from './pages/Clientes';
import Productos from './pages/Productos';
import AutoLogin from './pages/AutoLogin';


const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/autologin" element={<AutoLogin />} />
        <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/nueva" element={<PrivateRoute><NuevaCotizacion /></PrivateRoute>} />
        <Route path="/cotizacion/:id" element={<PrivateRoute><VerCotizacion /></PrivateRoute>} />
        <Route path="/cotizacion/:id/editar" element={<PrivateRoute><EditarCotizacion /></PrivateRoute>} />
        <Route path="/clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
        <Route path="/productos" element={<PrivateRoute><Productos /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;